<footer class="icip-footer" aria-label="Footer">
  <div class="icip-footer__container">

    <div class="icip-footer__main">

      <!-- Left: Logo + Newsletter -->
      <div class="icip-footer__brand">
        <div class="icip-footer__logo" aria-label="First Orion">
          <img src="assets/images/fo-logo.svg" alt="First Orion" width="140" height="32" loading="lazy" />
        </div>
        <div class="icip-footer__divider" aria-hidden="true"></div>
        <!-- <div class="icip-footer__newsletter">
          <div class="icip-footer__newsletter-title">Stay Updated</div>
          <p class="icip-footer__newsletter-sub">Platform news &amp; enterprise insights.</p>
          <div class="icip-footer__form" *ngIf="!submitted">
            <input
              class="icip-footer__email"
              type="email"
              [(ngModel)]="email"
              placeholder="Work email address"
              aria-label="Work email address"
            />
            <button
              class="icip-footer__submit"
              type="button"
              (click)="submit()"
              aria-label="Subscribe"
            >
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <line x1="5" y1="12" x2="19" y2="12"/>
                <polyline points="12 5 19 12 12 19"/>
              </svg>
            </button>
          </div>
          <p *ngIf="submitted" class="icip-footer__newsletter-thanks">Thanks for subscribing!</p>
        </div> -->
      </div>

      <!-- Platform + Company columns -->
      <div class="icip-footer__links" *ngFor="let g of groups">
        <div class="icip-footer__group-title">{{ g.title }}</div>
        <a
          class="icip-footer__link"
          *ngFor="let l of g.links"
          [href]="l.href"
          [attr.target]="l.target"
          [attr.rel]="l.target === '_blank' ? 'noopener noreferrer' : null"
          (click)="onFooterLinkClick($event, l)"
        >
          {{ l.label }}
        </a>
      </div>

      <!-- Follow Us column -->
      <div class="icip-footer__follow">
        <div class="icip-footer__group-title">Follow Us</div>
        <a
          class="icip-footer__social"
          *ngFor="let s of social"
          target="_blank"
          [href]="s.href"
          [attr.aria-label]="s.label"
        >
          <span class="icip-footer__social-icon" aria-hidden="true" [ngSwitch]="s.icon">
            <svg *ngSwitchCase="'linkedin'" viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true">
              <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.11 1 2.5 1s2.48 1.12 2.48 2.5zM.22 8h4.56v15H.22V8zm7.62 0h4.37v2.05h.06c.61-1.15 2.1-2.36 4.32-2.36 4.62 0 5.47 3.04 5.47 7v8.31h-4.56v-7.37c0-1.76-.03-4.03-2.45-4.03-2.46 0-2.84 1.92-2.84 3.9V23H7.84V8z"/>
            </svg>
            <svg *ngSwitchCase="'twitter'" viewBox="0 0 24 24" width="13" height="13" fill="currentColor" aria-hidden="true">
              <path d="M18.244 2H21.5l-7.5 8.57L23 22h-6.86l-5.37-7.02L4.6 22H1.34l8.02-9.16L1 2h7.03l4.86 6.43L18.24 2zm-1.2 18h1.86L7.04 4H5.06l11.98 16z"/>
            </svg>
            <svg *ngSwitchCase="'youtube'" viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true">
              <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1c.4-1.9.5-3.8.5-5.8s-.1-3.9-.5-5.8zM9.6 15.6V8.4l6.3 3.6-6.3 3.6z"/>
            </svg>
            <svg *ngSwitchCase="'facebook'" viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true">
              <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.77l-.44 2.89h-2.33v6.99A10 10 0 0 0 22 12z"/>
            </svg>
          </span>
          {{ s.label }}
        </a>
      </div>

    </div>

    <div class="icip-footer__bottom">
      <ul class="footer-links" [ngClass]="{ 'white-text': isWhiteText }">
        <li>
          <a
            href="https://firstorion.com/first-orion-global-privacy-and-compliance-dashboard/"
            target="_blank"
            rel="noopener noreferrer"
          >
            First Orion Legal Dashboard
          </a>
        </li>
        <li>
          <a
            href="https://firstorion.com/legal/acceptable-use-policy-euro/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Acceptable Use
          </a>
        </li>
        <li>
          <a href="#" (click)="openPrivacyChoices($event)">
            <img src="assets/images/privacy-choice.svg" alt="Privacy Icon" width="20" height="14" loading="lazy" />
            Your Privacy Choices</a
          >
        </li>
        <li>
          <small> © First Orion Corp. | All rights reserved.</small>
        </li>
      </ul>
    </div>

  </div>
</footer>
